import styles from "./InvoicesItem.module.scss";
import download from "../../assets/icons/download.svg";
import downloadHover from "../../assets/icons/download-hover.svg";
import { formatPriceWithCurrency } from "../../utils";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useToast } from "../../hooks/useToast";
import { trackEvent } from "../../utils/analytics";
import { EVENT_NAMES } from "../../types/event-names";

interface InvoicesItemProps {
  id: string;
  date: string;
  product: string;
  price: string;
  currency: string;
  receiptUrl: string;
}

const InvoicesItem: React.FC<InvoicesItemProps> = ({ id, date, product, price, currency, receiptUrl }) => {
  const { showToast } = useToast();
  const [showTooltip, setShowTooltip] = useState(false);

  const { t } = useTranslation();

  return (
    <>
      <div className={styles.row}>
        <p className={styles.item}>{id}</p>
        <p className={styles.item}>{date}</p>
        <p className={styles.item}>{product}</p>
        <p className={styles.item}>{formatPriceWithCurrency(price, currency)}</p>

        {receiptUrl ? (
          <img
            className={styles.item}
            src={download}
            onMouseOver={(e) => (e.currentTarget.src = downloadHover)}
            onMouseOut={(e) => (e.currentTarget.src = download)}
            onClick={() => {
              trackEvent(EVENT_NAMES.INVOICE_DOWNLOADED, {
                source: "invoices",
                sourceScreen: "invoices",
              });
              showToast("Your invoice is being generated! It will open in a new tab shortly.");
              setTimeout(() => {
                window.open(receiptUrl, "_blank");
              }, 300);
            }}
            alt="download"
            height={24}
            width={24}
          />
        ) : (
          <div className={styles.item}>
            <img
              className={styles.disabled}
              src={download}
              onMouseOver={(e) => {
                setShowTooltip(true);
              }}
              onMouseOut={(e) => {
                setShowTooltip(false);
              }}
              alt="no download"
              height={24}
              width={24}
            />
            {showTooltip && (
              <div className={styles.row_tooltipWrapper}>
                <p>{t("Invoice unavailable. Contact support for assistance.")}</p>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default InvoicesItem;
